export enum StoreKey {
	APP = 'app',
	CREATOR = 'creator',
}
